import { Modal } from "@material-ui/core";
import { Column, FormWrapper, ModalBody, Row } from "./customerSettings.styled";
import { ButtonStyled } from "components/buttons/buttons.styled";
import { Color } from "config/colors";
import { H4, Text } from "components/Typography/text.styled";
import { TextInput } from "components/form/inputs/inputs.styled";
import { useState } from "react";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import { CompanyCustomer } from "model/Company";
import { useTranslation } from "react-i18next";

type Props = {
  setShowAddCustomerForm: React.Dispatch<React.SetStateAction<boolean>>;
  showAddCustomerForm: boolean;
  saveCustomer(customer: any): void;
};

export const AddCustomerForm: React.FC<Props> = ({
  setShowAddCustomerForm,
  showAddCustomerForm,
  saveCustomer,
}) => {
  const { t } = useTranslation();

  const [companyState, companyActions] = useCompanyStore();
  const [customerName, setCustomerName] = useState("");
  const [customerOrgNr, setCustomerOrgNr] = useState("");
  const [customerContact, setCustomerContact] = useState("");

  return (
    <>
      <Modal
        open={showAddCustomerForm}
        onClose={() => {
          setShowAddCustomerForm(false);
        }}
      >
        <ModalBody>
          <H4>{t("CompanyCustomers.AddCustomer")}</H4>
          <FormWrapper>
            <Row>
              <Column>
                <>
                  <Text>{t("CompanyCustomers.Name")}</Text>
                  <TextInput
                    onChange={(e) => setCustomerName(e.target.value)}
                  ></TextInput>
                </>
              </Column>
              <Column>
                <>
                  <Text>{t("CompanyCustomers.OrganizationNumber")}</Text>
                  <TextInput
                    onChange={(e) => setCustomerOrgNr(e.target.value)}
                  ></TextInput>
                </>
              </Column>
            </Row>
            <Row>
              <Column>
                <Text>{t("CompanyCustomers.Contact")}</Text>
                <TextInput
                  onChange={(e) => setCustomerContact(e.target.value)}
                ></TextInput>
              </Column>
            </Row>
            <Row style={{ marginTop: 20 }}>
              <Column>
                <ButtonStyled
                  fullWidth
                  backgroundColor={Color.MidnightBlue}
                  onClick={() => setShowAddCustomerForm(false)}
                >
                  {t("General.Close")}
                </ButtonStyled>
              </Column>
              <Column>
                <ButtonStyled
                  disabled={!customerContact || !customerName || !customerOrgNr}
                  fullWidth
                  backgroundColor={Color.BurntSienna}
                  onClick={() => {
                    let companyId = companyState.company?.id;
                    if (companyId) {
                      let customer: CompanyCustomer = {
                        companyId: companyId,
                        name: customerName,
                        organizationNumber: customerOrgNr,
                        contact: customerContact,
                      };
                      saveCustomer(customer);
                      setShowAddCustomerForm(false);
                    }
                  }}
                >
                  {t("General.Save")}
                </ButtonStyled>
              </Column>
            </Row>
          </FormWrapper>
        </ModalBody>
      </Modal>
    </>
  );
};
